import dayjs from 'dayjs';

import { FetchUsersResponseType } from './useSearchCandidates';

export interface CandidatesDataType {
  key: React.Key;
  uuid: string;
  firstName: string;
  lastName: string;
  expectedSalary: string;
  recommendedBy: string;
}

export const useCandidateTableDataSource = (data: FetchUsersResponseType | undefined): CandidatesDataType[] => {
  if (!data) {
    return [];
  }

  const dataToMap = data?.results;

  return dataToMap.map((element) => {
    return {
      key: element.uuid,
      uuid: element.uuid,
      firstName: element.firstName,
      lastName: element.lastName,
      appliedPosition: element.appliedPosition,
      createdDate: dayjs.unix(element.createdDate).format('YYYY-MM-DD'),
      expectedSalary: element.expectedSalary,
      recommendedBy: element.recommendedBy,
    };
  });
};
